function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { CGM_INTERVAL } from 'modules/PatientResults/constants';
export const getAggregateHeightStyle = (level)=>{
    const baseHeight = level.rOffset ? level.rHeight / 2 + level.rOffset : level.rHeight;
    return {
        height: `calc(${baseHeight / level.height * 100}% + 8px)`
    };
};
const baseAGCL = {
    name: null,
    count: 0,
    percentage: 0,
    height: 0,
    rHeight: 0,
    rOffset: 0
};
export const getAggregatedGCL = (glucoseConcentrationLevels, dataType)=>{
    if (dataType === 'BGM') {
        return glucoseConcentrationLevels;
    }
    const aggregatedGCL = [
        _object_spread_props(_object_spread({}, baseAGCL), {
            name: 'high'
        }),
        _object_spread_props(_object_spread({}, baseAGCL), {
            name: 'target'
        }),
        _object_spread_props(_object_spread({}, baseAGCL), {
            name: 'low'
        })
    ];
    glucoseConcentrationLevels.forEach((gcl)=>{
        let aIdx = 0;
        if (gcl.name === 'target' || gcl.name === 'tight') aIdx = 1;
        if (gcl.name === 'low' || gcl.name === 'veryLow') aIdx = 2;
        aggregatedGCL[aIdx].count += gcl.count;
        aggregatedGCL[aIdx].percentage += gcl.percentage;
        if (aggregatedGCL[aIdx].height !== undefined) {
            const heightPercent = gcl.height;
            aggregatedGCL[aIdx].height += heightPercent;
            if (aggregatedGCL[aIdx].rHeight) aggregatedGCL[aIdx].rOffset = aggregatedGCL[aIdx].rHeight;
            aggregatedGCL[aIdx].rHeight += heightPercent * 0.5;
        }
    });
    return aggregatedGCL;
};
export const calculateCGMRangeTime = (aGCL)=>{
    const { percentage, count } = aGCL;
    const time = Math.round(count * CGM_INTERVAL * (percentage / 100));
    const m = time % 60;
    const hours = (time - m) / 60;
    let minutes = '';
    if (m > 0) {
        const mCounter = m.toString().padStart(2, '0');
        minutes = ` ${mCounter}m`;
    }
    return `${hours}h${minutes} `;
};
